import { put, call } from "redux-saga/effects";

import { SAVE_SESSION_COMPLETED,SAVE_SESSION_FAILED} from "../actions/Session";

import { SessionAPI } from "../../utils/api/sessioncheckAPI";



export function* saveSESSION(request: any) {
 
    
    try {
      
         const result=yield call(SessionAPI.sessionCheck, request.input);
    
        yield put({
            
            type: SAVE_SESSION_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_SESSION_FAILED, payload: e.message });
    }
}
    export function* getSESSION(request: any) {
   
        
        try {
   
             const result=yield call(SessionAPI.sessionLogin, request.input);
        
            yield put({
                
                type: SAVE_SESSION_COMPLETED,     
                payload: result.data,
                input: request.input
            });
        } catch (e) {
            yield put({ type: SAVE_SESSION_FAILED, payload: e.message });
        }
}
